/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_Summary_TitleInputs */



/**
* | output |
* | --- |
* | "Configuration Summary" |
*
* @param {Options_Cli_Summary_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_summary_title = /** @type {((inputs?: Options_Cli_Summary_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Summary_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Résumé de la configuration")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurationsübersicht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riepilogo della configurazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сводка по конфигурации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resumen de configuración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("配置摘要")
	if (locale === "ja") return /** @type {LocalizedString} */ ("構成の概要")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कॉन्फ़िगरेशन सारांश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resumo da configuração")
	return /** @type {LocalizedString} */ ("Configuration Summary")
});